module.exports = __webpack_public_path__ + "static/media/indoor_icon.ad893f2b.svg";